import Store from "./Store";
import {TicketMessage} from "../../model/ticket-message.model";

export default class TicketMessageStore extends Store<TicketMessage> {
  protected override name: string = "messages";
}
